/**
 * 滚动到指定的元素顶部
 * @param {HTMLElement} el 指定的html元素
 * @param {{}} opt opt
 * @param {boolean} opt.mid 是否跳到居中位置
 * @return {void}
 */
export function scrollToElement(el, { mid = true, offset = 0 } = {}) {
    if (!el || !el.getBoundingClientRect) {
        return;
    }
    const { top, height } = el.getBoundingClientRect();
    let to = top + getScrollTop();

    //居中位置，而非屏幕顶端
    if (mid) {
        to -= (window.screen.height - height) / 2;
    }

    to += offset;

    try {
        // window.scrollTo({ top: to, behavior: 'smooth' });
        // FIXME: 暂时不用 smooth，过渡动画有点奇怪
        window.scrollTo(0, to);
    } catch (er) {
        window.scrollTo(0, to);
    }
}

/**
 * 检查元素是否在视口内的不同状态
 * @param {Element} element
 * @param {string} checkType - 检查类型: 'entire', 'top', 'below'
 * @returns {boolean}
 */
export function isElementInViewport(element, checkType) {
    if (!element || !(element instanceof Element)) {
        return false;
    }

    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    switch (checkType) {
        case 'entire':
            return rect.top >= 0 && rect.bottom <= windowHeight + 1;
        case 'top':
            return rect.top >= 0 && rect.top <= windowHeight + 1;
        case 'below':
            return rect.top > windowHeight;
        default:
            throw new Error('Invalid checkType');
    }
}

/*
 * @since 1.0.0
 * @return {Number} top值
 * @example
 * base.getScrollTop();
 */
function getScrollTop() {
    return Math.max(document.documentElement.scrollTop, document.body.scrollTop);
}

/**
 * 判断是否为编辑器
 */
export function isEditor() {
    return !!window.FEGOEditor;
}

/**
 * 是否预渲染环境下
 * @returns {boolean}
 */
export function isPreRender() {
    if (isEditor()) {
        return false;
    }
    const {
        common: {
            env: { isPreRender: isPreRenderFlag }
        }
    } = require('@futuweb/fego-render');
    return isPreRenderFlag;
}
